import React from 'react';

const IconTwitter: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    focusable='false'
    role='presentation'
    fill='none'
    {...props}
    className={`icon icon-twitter${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M20.625 4.60208C20.0941 5.39399 19.4259 6.08457 18.6519 6.6412C18.7555 9.0216 18.1044 11.3739 16.7915 13.3622C16.1648 14.3229 15.4035 15.1888 14.531 15.9335C13.6565 16.6815 12.6046 17.2768 11.3767 17.721C10.1098 18.1715 8.77376 18.3967 7.42912 18.3865C5.28112 18.3995 3.17637 17.7828 1.375 16.6127C1.6877 16.6484 2.00214 16.6668 2.31687 16.6677C4.09761 16.6849 5.82982 16.0876 7.2215 14.9765C6.39215 14.9685 5.58779 14.6916 4.92938 14.1872C4.26936 13.6998 3.78076 13.0158 3.53375 12.2333C4.12551 12.347 4.73538 12.3244 5.31713 12.1673C4.42418 11.9959 3.62086 11.5136 3.04975 10.8061C2.45769 10.1045 2.13799 9.21326 2.14912 8.29533V8.2472C2.70875 8.55658 3.30413 8.72158 3.938 8.74083C3.40131 8.38389 2.96072 7.90033 2.65513 7.33283C2.33989 6.75775 2.17662 6.11175 2.18075 5.45595C2.18075 4.74508 2.3595 4.0837 2.71425 3.47045C3.69958 4.68179 4.92648 5.67455 6.31675 6.38545C7.724 7.11243 9.27195 7.52615 10.8542 7.5982C10.7841 7.30361 10.7491 7.00177 10.7498 6.69895C10.7498 5.60858 11.1347 4.6777 11.9075 3.9077C12.269 3.53431 12.7032 3.23894 13.1833 3.03982C13.6633 2.8407 14.1791 2.74205 14.6987 2.74995C15.84 2.74995 16.8025 3.1652 17.5821 3.9957C18.4669 3.82235 19.3152 3.49817 20.0901 3.03733C19.8083 3.95895 19.1885 4.73992 18.3549 5.22358C19.1385 5.13052 19.9037 4.92194 20.625 4.60208Z'
      fill=''
    />
  </svg>
);
export default IconTwitter;
